import { ArrowUp } from "lucide-react";

export const Footer = () => (
  <footer data-testid="footer" className="relative border-t border-stone-800/70 bg-[#0C0A09] overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
      <div className="flex flex-col items-center text-center">
        <img
          data-testid="footer-logo"
          src="/logo.png"
          alt="PETRAITS by Bash & Bird"
          className="w-44 h-44 sm:w-56 sm:h-56 rounded-full shadow-[0_20px_60px_-15px_rgba(65,194,242,0.45)]"
        />
        <p className="mt-8 text-sm text-stone-500 max-w-md leading-relaxed">
          Fine art pet portraits, painted by hand after a real conversation — never printed, never generated, never rushed.
        </p>
        <a
          data-testid="footer-email-link"
          href="mailto:info@petraits.net"
          className="mt-6 text-sm text-stone-300 hover:text-[#41C2F2] transition-colors border-b border-stone-700 hover:border-[#41C2F2] pb-0.5"
        >
          info@petraits.net
        </a>
      </div>

      <div className="mt-16 pt-8 border-t border-stone-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-stone-600">© 2026 <span className="font-serif tracking-[0.22em] font-semibold text-xs text-stone-500">PETRAITS</span> · Every portrait an original</p>
        <div className="flex items-center gap-6">
          <a data-testid="footer-studio-link" href="/studio" className="text-xs text-stone-600 hover:text-[#41C2F2] transition-colors">Studio</a>
          <button
            data-testid="footer-back-to-top"
            onClick={() => window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.6 }) : window.scrollTo({ top: 0, behavior: "smooth" })}
            className="inline-flex items-center gap-2 text-xs text-stone-500 hover:text-[#41C2F2] transition-colors"
          >
            Back to top <ArrowUp className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  </footer>
);
